import { useFrontendTool } from "@copilotkit/react-core"
import farmSo from "stores/farm"
import metaSo from "stores/metadata"
import { ADJ_PROPS } from "stores/plc/utils/adj"
import { getPLCAlerts, updatePLCAlerts } from "stores/plc/utils/alerts/utils"
import valuesSo from "stores/values"
import { delayUntil } from "utils"
import { plcAlertToCopilot } from "./utils/toCopilot"
import { TOOLS } from "./utils/types"



/**
 */
export function useGetPLCValues() {

	useFrontendTool({
		name: "get_growunit_plc_values",
		description: `Restituisce i valori attuali PLC-VALUES dell'HARDWARE di una specifica GROWUNIT.
ATTENZIONE: deve essere selezionata una FARM (tool: ${TOOLS.NAVIGATE_IN_FARM_SECTION}) prima di poter usare questo tool.
BONUS: se il fine è dare i valori all'utente visualizza a schermo anche la corretta GROWUNIT e GROWUNIT-SECTION (tool: ${TOOLS.NAVIGATE_IN_GROWUNIT_SECTION}).
VALORI RESTITUITI:
- PH (acidità del nutrimento): setpoint, measured, delta
- EC (elettroconduttività del nutrimento): setpoint, measured, delta
`,
		parameters: [
			{
				name: "growunit_code",
				description: "il code della GROWUNIT",
				type: "string",
				required: true,
			}
		],
		handler: async ({ growunit_code }) => {
			if (farmSo.state.select == null) return {
				success: false,
				error: `Devi selezionare una FARM prima. Usa il tool "${TOOLS.NAVIGATE_IN_FARM_SECTION}" per selezionare una FARM e poi ripeti questa azione.`
			}
			const component = farmSo.getComponentByCode(growunit_code) ?? farmSo.getComponentByGrowUnitCode(growunit_code)
			if (!component) return {
				success: false,
				error: `Nessun COMPONENT associato alla GROWUNIT con code "${growunit_code}"`
			}
			const code = component.subjects?.[0]
			return {
				success: true,
				data: await getAdjValues(code)
			}
		},
	})

	useFrontendTool({
		name: "get_farm_plc_warnings",
		description: `Restituisce i PLC-WARNING presenti nella FARM selezionata
Si tratta di allarmi che arrivano dal PLC dell'HARDWARE della FARM. Ogni allarme è associato ad un COMPONENT specifico (per esempio: GROWUNIT) e ha un codice identificativo e una descrizione.
ATTENZIONE: deve essere selezionata una FARM (tool: ${TOOLS.NAVIGATE_IN_FARM_SECTION}) prima di poter usare questo tool.
VALORI RESTITUITI:
- code: identificativo
- description: breve descrizione
- component_code: COMPONENT a cui fa riferimento
- isAck: indica se l'allarme è stato ACK (mutato) dall'utente
`,
		parameters: [
		],
		handler: async () => {
			if (farmSo.state.select == null) return {
				success: false,
				error: `Devi selezionare una FARM prima. Usa il tool ${TOOLS.NAVIGATE_IN_FARM_SECTION} per selezionare una FARM e poi ripeti questa azione.`
			}

			// controllo che i metadata sia coaricati
			await delayUntil(() => metaSo.state.metadata != null)
			// carico tutti i PLC-WARNING dai metadata
			let alerts = getPLCAlerts()
			// attendo che si possa caricare almeno il primo
			const tmp = await valuesSo.getNumberByAliasAsync({ alias: alerts[0].alias, code: alerts[0].code })
			// dal PLC verifico quelli attivi e aggiorno il loro stato di ACK
			alerts = updatePLCAlerts(alerts)

			if (!alerts || alerts.length == 0) return {
				success: true,
				message: "Nessun PLC-WARNING attivo al momento.",
				data: []
			}
			return {
				success: true,
				data: alerts.map(alert => plcAlertToCopilot(alert)),
			}
		},
	})
}



/**
 * Restituisce i valori attuali PLC dell'HARDWARE di una specifica GROWUNIT.
 */
async function getAdjValues(code: string) {
	return {
		pH: {
			measured: await valuesSo.getNumberByAliasAsync({ alias: ADJ_PROPS.PH_MESURED, code }),
			setpoint: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.PH_SETPOINT, code }),
			delta: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.PH_DELTA, code }),
			unit: "pH",
		},
		EC: {
			measured: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.EC_MESURED, code }),
			setpoint: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.EC_SETPOINT, code }),
			delta: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.EC_DELTA, code }),
			unit: "mS",
		},
	}
}